import React, { useState, useRef } from "react";
import "./contentpage.css";
import Question from "../components/Question";
import LandingSection from "./LandingSection";
import FloatingPageNav from "../components/FloatingPageNav";
import { Link } from "react-router-dom";

function IslamicTradePage22() {
const contentRef = useRef(null);
     const links = {
    prev: "/islamic-trade-page-21", 
    index: "/index",                 
    next: "/islamic-trade-page-23", 
  };
  const titleText = "The Pre-Emption Right in Property (Shuf'ah)";
  const questions = [
    {
      text: "1. What is the primary purpose of the Shuf‘ah (pre-emption) right in Islamic law?",
      options: [
        {
          value: "A",
          label:
            "A. To allow anyone in the market to purchase land.",
        },
        {
          value: "B",
          label:
            "B. To ensure the highest price is obtained for the property.",
        },
        {
          value: "C",
          label:
            "C. To preserve harmony among co-owners or neighbors by preventing disputes.",
        },
        {
          value: "D",
          label:
            "D. To allow the government to regulate property sales.",
        },
      ],
      correct: "C",
    },
    {
      text: "2.  In which of the following situations does the right of Shuf‘ah not apply?",
      options: [
        { value: "A", label: "A. A co-owner sells their share to a third party." },
        { value: "B", label: "B. A partner rents out their share." },
        { value: "C", label: "C. A neighbor offers to buy a property at the same price." },
        { value: "D", label: "D. A co-owner decides to sell their portion of farmland." },
      ],
      correct: "B",
    },
    {
      text: "3. According to Islamic law, the right of Shuf‘ah applies to which type of property?",
      options: [
        { value: "A", label: "A. All types of assets, movable and immovable." },
        { value: "B", label: "B. Only movable property such as vehicles and tools." },
        { value: "C", label: "C. Only land and immovable property." },
        { value: "D", label: "D. Any jointly owned business or commercial interest." },
      ],
      correct: "C",
    },
    {
      text: "4. Who retains ownership of the fruits or crops on the land at the time of a Shuf‘ah sale?",
      options: [
        { value: "A", label: "A. The buyer" },
        { value: "B", label: "B. The local community" },
        { value: "C", label: "C. The seller" },
        { value: "D", label: "D. Shared equally between buyer and seller" },
      ],
      correct: "C",
    },
  ];
  // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);

  return (
    <div className="container">

      <LandingSection
        titleText={titleText}
        scrollToRef={contentRef}
        progressValue={22}
        timerMinutes={45}
        currentLevel={1}
      />
    

      <p className="content" ref={contentRef}>
        Welcome to <b>Day 22</b>! Today, we turn our attention to Shuf’ah, the
        Islamic right of pre-emption in property. This principle safeguards
        harmony within communities by granting co-owners or immediate neighbors
        the first right to purchase a property share when it is being sold.
        Rooted in the Prophet’s (peace be upon him) teachings, Shuf’ah helps
        prevent disputes, maintain close-knit social ties, and ensure fairness
        in shared ownership arrangements. As we delve into the conditions,
        scope, and wisdom of this right, we’ll uncover how Islamic law balances
        individual freedom with the collective well-being of neighbors and
        co-owners.
        <br />
        <br />
        Shuf’ah, or the pre-emption right in Islamic law, is a legal principle
        that grants co-owners or immediate neighbors the first right to purchase
        a share of a jointly owned property if one of the partners decides to
        sell. This right ensures that the property remains within the existing
        circle of owners or neighbors, preserving harmony and minimizing
        potential disputes caused by introducing an outsider. It applies only
        when the co-owner or neighbor is willing to pay the same price as the
        third party.
        <br /> The Prophet Muhammad (peace and blessings be upon him) emphasized
        this principle, stating that <br />
        “The neighbor has more right to be taken care of by his neighbor,”{" "}
        <i>
          <a href="https://sunnah.com/bukhari/90/28" target="blank">
            (Sahih al-Bukhari 6981)
          </a>
        </i>
        and that this right is particularly relevant when boundaries are not
        clearly divided
        <br />
        However, Shuf’ah is not applicable in all cases of property transfer.
        For example, if a partner’s share of the property is transferred to
        another owner due to religious obligations, such as inheritance or
        fulfillment of a bequest, the pre-emption right does not apply. This
        exception recognizes the priority of fulfilling religious duties over
        the co-owner’s preference to purchase the share. <br />
        Similarly, the right of Shuf’ah does not apply in cases where a partner
        rents out their share of the property. Since renting does not alter
        ownership or permanently transfer the property, it is not treated as a
        sale, and therefore, the pre-emption right does not arise.
        <br />
        The right of Shuf’ah is strictly limited to cases of outright sale of a
        partner’s share. This distinction ensures that the principle remains
        focused on maintaining communal harmony without unnecessarily
        interfering in transactions that do not fundamentally change the
        ownership structure. The conditions and limitations placed on Shuf’ah
        highlight the balance in Islamic law between protecting individual
        rights and fulfilling broader social and religious responsibilities,
        ensuring fairness in property transactions while preserving the rights
        of all stakeholders.
        <br />
        <br />
        <b>Shuf'ah: Specificity to Land Ownership</b>
        <br />
        <br />
        The principle of Shuf'ah in Islamic law is specific to land and
        immovable property; it does not apply to other jointly owned assets such
        as vehicles, furniture, or other movable property. This distinction
        arises from the unique nature of land, which often involves shared
        boundaries, communal access, or proximity that could be affected by
        introducing a new owner. Movable assets, such as cars, do not carry the
        same implications for co-ownership or neighborly relations and therefore
        fall outside the scope of Shuf'ah. The restriction of this right to
        immovable property emphasizes the importance of maintaining social
        harmony and safeguarding communal relationships in matters of shared
        land.
        <br />
        <br />
        <b>Ownership of Agricultural Produce in Shuf'ah Transactions</b>
        <br />
        <br />
        When land subject to Shuf'ah contains fruits on trees or agricultural
        produce, the current produce at the time of sale belongs to the seller,
        as it is considered a result of their effort and resources. The right of
        Shuf'ah pertains strictly to the land itself, not to the produce it
        yields before the sale. However, future produce will belong to the new
        owner, as they assume ownership and responsibility for the land moving
        forward. This differentiation reflects the equitable treatment of
        ownership rights in Islamic law, ensuring the seller retains the
        benefits of their labor while the buyer gains the full rights to the
        land and its potential future yield.
        <br />
        <br />
        <b>Summary of Today's Lesson</b>
        <br />
        <br />
        Today’s lesson explored the concept of Shuf‘ah, the pre-emption right in
        Islamic property law, which grants co-owners or immediate neighbors the
        first opportunity to purchase a jointly owned property share before it
        is sold to an outsider. We learned that this right helps preserve
        harmony, prevent disputes, and maintain neighborhood integrity. The
        session clarified that Shuf‘ah applies only to immovable property like
        land and not to movable items such as vehicles or furniture. We also
        studied exceptions where Shuf‘ah does not apply, such as inheritance or
        rental agreements, and noted that any existing agricultural produce on
        the land remains the seller’s property, while future produce belongs to
        the buyer.
        <br />
        <br />
        <b>Coming Up Next</b>
        <br />
        <br />
        As we transition into Day 23, we explore an exciting and highly
        practical area of Islamic contractual law Ja’aalah, or the task-specific
        reward contract. This form of agreement provides flexibility for
        rewarding someone for completing a task where the time, effort, or
        outcome is uncertain i.e like finding a lost item or solving a problem.
        Unlike fixed employment, Ja’aalah is ideal for situations requiring
        open-ended performance or incentivized results. Supported by prophetic
        practice and Qur'anic values of fairness and clarity, this contract type
        emphasizes transparency in reward, mutual consent, and protection
        against harm. In our next session, we'll learn how Ja’aalah balances
        ethical reward systems with contractual freedom in a Shariah-compliant
        framework.
      </p>
      <h2>Test your understanding</h2>
      {questions.map((q, index) => (
              <Question
                key={index}
                questionText={q.text}
                options={q.options}
                correctAnswer={q.correct}
                onAnswer={(value) => handleAnswerChange(index, value)} // pass parent handler
              />
            ))}
      
            <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
              Score: {score} / {questions.length}
            </div>
   
    

       <FloatingPageNav 
              prevLink={links.prev} 
              indexLink={links.index} 
              nextLink={links.next} 
            />
    </div>
  );
}

export default IslamicTradePage22;
